(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bronzata-header"]) return;
  try {
    
  (function(){
    var FLAGS={
      it:'<svg viewBox="0 0 24 24" preserveAspectRatio="xMidYMid slice"><rect width="8" height="24" x="0" fill="#009246"/><rect width="8" height="24" x="8" fill="#fff"/><rect width="8" height="24" x="16" fill="#ce2b37"/></svg>',
      eu:'<svg viewBox="0 0 24 24" preserveAspectRatio="xMidYMid slice"><rect width="24" height="24" fill="#039"/><g fill="#fc0">'+(function(){var s='';for(var i=0;i<12;i++){var a=i*30*Math.PI/180,x=12+7*Math.sin(a),y=12-7*Math.cos(a);s+='<path transform="translate('+x.toFixed(2)+','+y.toFixed(2)+')" d="M0,-1.7 0.5,-0.53 1.6,-0.53 0.64,0.2 1,1.38 0,0.66 -1,1.38 -0.64,0.2 -1.6,-0.53 -0.5,-0.53Z"/>';}return s;})()+'</g></svg>',
      uk:'<svg viewBox="0 0 24 24" preserveAspectRatio="xMidYMid slice"><rect width="24" height="24" fill="#012169"/><path d="M0,0 24,24M24,0 0,24" stroke="#fff" stroke-width="4.6"/><path d="M0,0 24,24M24,0 0,24" stroke="#C8102E" stroke-width="2.7"/><path d="M12,0V24M0,12H24" stroke="#fff" stroke-width="7.5"/><path d="M12,0V24M0,12H24" stroke="#C8102E" stroke-width="4.3"/></svg>'
    };
    var MARKETS=[{id:'it',sub:''},{id:'eu',sub:'/en-eu'},{id:'uk',sub:'/en-gb'}];
    var GROUPS=[
      {it:'body-coverage-perfector',uk:'body-coverage-perfector-uk',eu:'body-coverage-perfector-eu'},
      {it:'blend-blur-body-brush',uk:'blend-blur-body-brush-uk',eu:'blend-blur-body-brush-eu'}
    ];
    function findGroup(h){for(var i=0;i<GROUPS.length;i++){for(var k in GROUPS[i]){if(GROUPS[i][k]===h)return GROUPS[i];}}return null;}
    var COUNTRY={it:'IT',uk:'GB',eu:'DE'};
    function targetUrl(toId,handle,path){
      var m=null;for(var i=0;i<MARKETS.length;i++){if(MARKETS[i].id===toId)m=MARKETS[i];}
      var g=handle?findGroup(handle):null;
      if(g){var th=g[toId];if(th)return m.sub+'/products/'+th;return m.sub+'/';}
      var p=path||'/';
      // strip any existing market subfolder so we never double-prefix (e.g. /en-eu/en-gb)
      p=p.replace(/^\/en-eu(?=\/|$)/,'').replace(/^\/en-gb(?=\/|$)/,'');
      if(p===''||p.charAt(0)!=='/')p='/'+p;
      return m.sub+p;
    }
    // Switch market via Shopify localization form: sets the locale cookie (so geo-redirect
    // won't fight the choice) and hands Shopify the exact target path. Robust on repeated switches.
    function go(toId,handle,path){
      var ret=targetUrl(toId,handle,path);
      function submit(){
        var f=document.createElement('form');
        f.method='POST';f.action='/localization';f.style.display='none';
        f.innerHTML='<input type="hidden" name="_method" value="put">'
          +'<input type="hidden" name="form_type" value="localization">'
          +'<input type="hidden" name="country_code" value="'+(COUNTRY[toId]||'IT')+'">'
          +'<input type="hidden" name="return_to" value="'+ret+'">';
        document.body.appendChild(f);f.submit();
      }
      // A cart built in the current market holds products that don't exist in the target
      // market's catalog (Path B = separate product per market). Carrying them across →
      // "not available for delivery" at checkout. Clear the cart on switch so the new
      // market always starts clean. (Bundle line items can't be safely re-created, so we
      // clear rather than try to migrate them.)
      try{
        fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}}).then(submit,submit);
      }catch(e){ submit(); }
    }
    function init(root){
      if(root.__bzMktInit)return;root.__bzMktInit=true;
      var cur=root.getAttribute('data-current')||'it';
      var handle=root.getAttribute('data-handle')||'';
      var path=root.getAttribute('data-path')||'/';
      var curEl=root.querySelector('[data-bz-cur-flag]');
      var menu=root.querySelector('[data-bz-menu]');
      var trig=root.querySelector('.bz-mkt__trigger');
      if(curEl)curEl.innerHTML=FLAGS[cur]||FLAGS.it;
      var html='';
      MARKETS.forEach(function(m){
        html+='<button class="bz-mkt__opt" type="button" role="menuitem" data-id="'+m.id+'"'+(m.id===cur?' data-current aria-current="true"':'')+'><span class="bz-mkt__flag">'+(FLAGS[m.id]||'')+'</span></button>';
      });
      menu.innerHTML=html;
      function open(){root.setAttribute('data-open','');trig.setAttribute('aria-expanded','true');}
      function close(){root.removeAttribute('data-open');trig.setAttribute('aria-expanded','false');}
      trig.addEventListener('click',function(e){e.stopPropagation();root.hasAttribute('data-open')?close():open();});
      document.addEventListener('click',close);
      document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
      menu.querySelectorAll('.bz-mkt__opt').forEach(function(b){
        b.addEventListener('click',function(e){
          e.stopPropagation();var to=b.getAttribute('data-id');
          if(to===cur){close();return;}
          go(to,handle,path);
        });
      });
    }
    // ── Market-preserving link rewriter (Path B) ──────────────────────────
    // Every internal <a href> must (1) keep the visitor's market subfolder
    // prefix (/en-eu, /en-gb, or none for IT) and (2) point to the current
    // market's product handle. Without the prefix a link lands on the IT
    // primary domain → the EN product isn't in the IT catalog → 404 + market
    // switch. This makes it impossible to leave your market by clicking.
    // Idempotent: strips any existing prefix/handle first, then re-applies.
    function curMarketId(){
      var root=document.querySelector('[data-bz-mkt]');
      var cur=root?root.getAttribute('data-current'):'it';
      return cur||'it';
    }
    function subFor(id){for(var i=0;i<MARKETS.length;i++){if(MARKETS[i].id===id)return MARKETS[i].sub;}return '';}
    function rewriteMarketLinks(){
      var cur=curMarketId();
      var sub=subFor(cur); // '' | '/en-eu' | '/en-gb'
      var links=document.querySelectorAll('a[href]');
      for(var i=0;i<links.length;i++){
        var a=links[i];
        if(a.closest('[data-bz-mkt]'))continue;            // skip the switcher itself
        if(a.getAttribute('data-bz-keep'))continue;        // explicit opt-out
        var href=a.getAttribute('href')||'';
        if(!href||href.charAt(0)==='#')continue;
        if(/^(mailto:|tel:|sms:|javascript:)/i.test(href))continue;
        var path,query='';
        if(/^https?:\/\//i.test(href)){
          if(href.indexOf('bronzata.com')<0)continue;      // external domain → leave
          try{var u=new URL(href);path=u.pathname;query=u.search;}catch(e){continue;}
        }else if(href.charAt(0)==='/'){
          var qi=href.indexOf('?');path=qi<0?href:href.slice(0,qi);query=qi<0?'':href.slice(qi);
        }else{continue;}                                    // protocol-relative / other → skip
        if(path.indexOf('/cdn')===0||path.indexOf('//')===0)continue;
        // 1. normalise: strip any market prefix
        var bare=path.replace(/^\/en-eu(?=\/|$)/,'').replace(/^\/en-gb(?=\/|$)/,'');
        if(bare==='')bare='/';
        // 2. swap product handle to the current market's product
        var pm=bare.match(/^\/products\/([a-z0-9-]+)/);
        if(pm){
          var g=findGroup(pm[1]);
          if(g&&g[cur]&&g[cur]!==pm[1]){bare=bare.replace('/products/'+pm[1],'/products/'+g[cur]);}
        }
        // 3. re-apply the current market prefix
        var fixed=sub+bare;
        if(fixed!==path){a.setAttribute('href',fixed+query);}
      }
    }
    var _rwT;
    function scheduleRewrite(){clearTimeout(_rwT);_rwT=setTimeout(rewriteMarketLinks,120);}
    function boot(){
      document.querySelectorAll('[data-bz-mkt]').forEach(init);
      rewriteMarketLinks();
      // catch lazy-rendered links (Instant.so, product cards, app blocks)
      if(!window.__bzLinkMO){
        try{
          window.__bzLinkMO=new MutationObserver(scheduleRewrite);
          window.__bzLinkMO.observe(document.body,{childList:true,subtree:true});
        }catch(e){}
      }
    }
    if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
    window.addEventListener('load',rewriteMarketLinks);
    document.addEventListener('shopify:section:load',boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
